import FilterVintageIcon from '@mui/icons-material/FilterVintage';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SpaIcon from '@mui/icons-material/Spa';
import { Box } from '@mui/material';
import { ErmsCardEnum } from 'interfaces/erms';
import { useState } from 'react';
import ErmsSelectCard from './components/ErmsSelectCard';
import HarvestModule from './HarvestModule';
import ProductionModule from './ProductionModule';
import WeighbridgeModule from './WeighbridgeModule';

const ErmsContentComponents = () => {
  const [selectedCard, setSelectedCard] = useState<ErmsCardEnum>(ErmsCardEnum.HARVEST);

  const listSelectCard = [
    { key: 1, value: ErmsCardEnum.HARVEST, label: 'Harvest', avatar: <SpaIcon /> },
    { key: 2, value: ErmsCardEnum.PRODUCTION, label: 'Production', avatar: <FilterVintageIcon /> },
    { key: 3, value: ErmsCardEnum.WEIGHBRIDGE, label: 'Weighbridge', avatar: <LocalShippingIcon /> },
  ];

  const renderModule = (card: ErmsCardEnum) => {
    switch (card) {
      case ErmsCardEnum.PRODUCTION:
        return <ProductionModule />;
      case ErmsCardEnum.WEIGHBRIDGE:
        return <WeighbridgeModule />;
      case ErmsCardEnum.HARVEST:
      default:
        return <HarvestModule />;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box sx={{ display: 'flex', gap: '12px' }}>
        {listSelectCard.map((item) => (
          <ErmsSelectCard key={item.key} item={item} selectedCard={selectedCard} setSelectedCard={setSelectedCard} />
        ))}
      </Box>
      {renderModule(selectedCard)}
    </Box>
  );
};

export default ErmsContentComponents;
